import React, { MouseEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, List, ListItem, ListItemText, Popover, Typography, useTheme, useMediaQuery } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { signOutComplete } from '~store/account/actions'
import { signOut } from '~utils/msal/msalAuthentication'
import { useAppBarItemStyles } from './AppBarItemStyles'
import { getAccountInfoUserName } from '~store/account/selectors'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

const AccountMenu: React.FC = () => {
  const { t } = useTranslation()
  const s = useAppBarItemStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const userName = useSelector(getAccountInfoUserName)
  const [anchorEl, setAnchorEl] = React.useState<null | Element>(null)
  const theme = useTheme()
  const isMobileXs = useMediaQuery(theme.breakpoints.down('xs'))
  const isMobileXXs = useMediaQuery('(max-width:345px)')

  const handleOpenPopover = (event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => setAnchorEl(event.currentTarget)
  const handleClosePopover = () => setAnchorEl(null)

  const handleAccountLogout = () => {
    const signOutSuccess = signOut()
    signOutSuccess && dispatch(signOutComplete())
  }

  const handleProfileNavigation = () => {
    history.push('/account#')
    handleClosePopover()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'AccountMenuPopover' : undefined

  return <>
    <Button
      onClick={handleOpenPopover}
      startIcon={!isMobileXXs && <PersonIcon />}
      endIcon={<ExpandMoreIcon />}
      color='inherit'
    >
      {
        !isMobileXs
        && <Typography className={s.centerButtonText} component='span'>
          {userName}
        </Typography>
      }
    </Button>

    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClosePopover}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <List disablePadding className={s.popoverContainer}>
        <ListItem button focusRipple onClick={handleProfileNavigation}>
          <ListItemText primary={t('common:myProfile')} />
        </ListItem>
        <ListItem button focusRipple onClick={handleAccountLogout}>
          <ListItemText primary='Logout' />
        </ListItem>
      </List>
    </Popover>
  </>
}

export default AccountMenu
